









































































































































































import type { User } from '@/models/user';
import type { UserSetting } from '@/models/userSetting';

import { Component, Vue } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import { userWebservice } from '@/webservices/user';
import { companyWebservice } from '@/webservices/company';
import { goToMainLink, goToNativeLink } from '@/helpers/routing/links';

@Component({
    name: 'Register',
    components: {},
})
export default class Register extends Vue {
    @Getter('account/loggedIn') private loggedIn: boolean;

    private errorMsg: string = '';
    private disabled: boolean = false;
    private validToken: boolean = true;
    private justRegistered: boolean = false;
    private companyName: string = '';
    private companyToken: string = '';

    private user: User = {
        id: 0,
        firstname: '',
        lastname: '',
        email: '',
        new_email: '',
        is_superadmin: false,
        password: '',
        new_password: '',
        email_confirmed: false,
        email_confirmation_token: '',
        address: '',
        address_addition: '',
        postcode: '',
        city: '',
        country: '',
        role_id: 0,
        disabled: false,
        settings: {} as UserSetting,
        company_id: 0,
    };

    // Mounted is called initially
    private mounted() {
        this.loadCompanyByToken();
    }

    private loadCompanyByToken() {
        if (this.$route.query.hasOwnProperty('token')) {
            this.companyToken = this.$route.query.token.toString();
            const self = this;
            companyWebservice.getCompanyNameByToken(this.companyToken).then(function (response) {
                if (response.data.hasOwnProperty('name') && response.data.name !== '') {
                    self.companyName = response.data.name;
                    self.validToken = true;
                } else {
                    self.validToken = false;
                }
            });
        } else {
            this.validToken = false;
        }
    }

    private register() {
        if (this.validate()) {
            this.disabled = true;
            userWebservice
                .register(this.user, this.companyToken)
                .then((response) => {
                    this.justRegistered = true;
                    goToNativeLink('auth/logout');
                    location.reload();
                })
                .catch((error) => {
                    console.log(error);
                    this.disabled = false;
                    this.errorMsg = error.response.data.message;
                    if (error.response.data.hasOwnProperty('email')) {
                        this.errorMsg = 'emailTaken';
                    }
                });
        }
    }

    private validate() {
        if (this.user.firstname === '') {
            // this.errorMsg = 'Please enter your Name';
            this.errorMsg = 'firstname';
            return 0;
        } else if (this.user.lastname === '') {
            this.errorMsg = 'lastname';
            return 0;
        } else if (!this.validateEmail(this.user.email)) {
            this.errorMsg = 'email';
            return 0;
        } else if (this.user.password === '' || this.user.password.length < 8) {
            this.errorMsg = 'password';
            return 0;
        } else {
            return true;
        }
    }

    private validateEmail(email) {
        // tslint:disable-next-line:max-line-length
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email.toLowerCase());
    }
}
